import { Injectable } from '@angular/core';
import { SimpleConfigBaseFilter, ConfigBaseFilter } from 'gung-list';
import { Pim, PimListConfigService, gungComparatorHelper } from 'gung-standard'
import { Observable, first, map, tap } from 'rxjs';

export class OemFilter extends SimpleConfigBaseFilter<Pim> {
  constructor() {
    super();
  }

  getName(): string {
    return 'OEM';
  }

  getOptionIds(item: Pim): string[] {
    if (item?.extra?.pim?.OEM){
      const oem = item.extra.pim.OEM as string;
      return oem.split(',');
    }
    return [];
  }
  getOptionName(key: string): string {
    return key;
  }
}


@Injectable({
  providedIn: 'root'
})
export class CarLinerPimListConfigService extends PimListConfigService {

  getFilters(): ConfigBaseFilter<Pim>[] {
    const filters = super.getFilters();
    filters.push(new OemFilter());
    return filters;
  }

  getItems(): Observable<Pim[]> {
    return this.pimService.getPimProducts().pipe(
      first(),
      map(data => data.sort((a, b) => gungComparatorHelper(a.dateLastUpdate, b.dateLastUpdate, -1)))
    );
  }

}
